import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {ApiLocationService} from '@services/api-location/api-location.service';
import {Observable} from 'rxjs';
import {HTTPS_REQUEST_OPTIONS} from '@constants/https-request-options/https-request-options';
import {MachineTag} from '@models/adminstration/machine/tag/machine-tag';

@Injectable({
  providedIn: 'root'
})
export class MachineTagService {
  private MACHINE_TAGS_LIST_FOR_CATEGORY_URL_SUFFIX = '/api/web/admin/machine/listTagsOfCategory/:category';
  private MACHINE_TAG_GET_FOR_CATEGORY_URL_SUFFIX = '/api/web/admin/machine/getTag/:category/:tag';
  private MACHINE_TAG_CHANGE_APPLY_TO_MACHINES_OF_SAME_TAG_URL_SUFFIX = '/api/web/admin/machine/changeApplyToMachinesOfSameTag/:category/:tag/:flag';
  private MACHINE_TAG_SYNC_TRAFFIC_LIGHT_SETTINGS_URL_SUFFIX = '/api/web/admin/machine/updateSyncTrafficLightSettingsFlag/:category/:tag/:flag';

  private readonly BASE_URL: string;

  constructor(
      private http: HttpClient,
      private apiLocation: ApiLocationService) {
    this.BASE_URL = this.apiLocation.getLocation();
  }

  public listMachineTagsForCategory(category: string): Observable<any> {
    let url: string = this.BASE_URL + this.MACHINE_TAGS_LIST_FOR_CATEGORY_URL_SUFFIX;
    url = url.replace(':category', category);
    return this.http.get(url, HTTPS_REQUEST_OPTIONS);
  }


  public getTag(category: string, tag: string): Observable<any> {
    let url: string = this.BASE_URL + this.MACHINE_TAG_GET_FOR_CATEGORY_URL_SUFFIX;
    url = url.replace(':category', category);
    url = url.replace(':tag', tag);
    return this.http.get(url, HTTPS_REQUEST_OPTIONS);
  }

  public changeApplyToMachinesOfSameTag(category: string, tag: string, flag: boolean): Observable<any> {
    let url: string = this.BASE_URL + this.MACHINE_TAG_CHANGE_APPLY_TO_MACHINES_OF_SAME_TAG_URL_SUFFIX;
    url = url.replace(':category', category);
    url = url.replace(':tag', tag);
    url = url.replace(':flag', String(flag));
    return this.http.post(url, flag, HTTPS_REQUEST_OPTIONS);
  }

  public changeSyncTrafficLightSettingsFlag(category: string, tag: string, flag: boolean): Observable<any> {
    let url: string = this.BASE_URL + this.MACHINE_TAG_SYNC_TRAFFIC_LIGHT_SETTINGS_URL_SUFFIX;
    url = url.replace(':category', category);
    url = url.replace(':tag', tag);
    url = url.replace(':flag', String(flag));
    return this.http.post(url, flag, HTTPS_REQUEST_OPTIONS);
  }


  public enhanceMachineTagsArray(category: string, tag: string | undefined, machineTags: MachineTag[] | undefined) {
    let result: MachineTag[] = [];
    if (!machineTags) {
      return result;
    }
    result = [...machineTags];

    if (!tag || tag.length === 0 || tag.trim().length === 0) {
      return result;
    }
    const machineTagToAdd = new MachineTag(category, tag);
    if (machineTags.length === 0) {
      result.push(machineTagToAdd);
    } else {

      const existingMachineTag = result.find(t => t.tag.toLowerCase() === tag.toLowerCase());
      if (!existingMachineTag) {
        result.unshift(machineTagToAdd);
      }
    }
    return result;

  }
}
